<template lang="html">

<b-container fluid>

<b-row>
  <b-col md="6" offset-md="6" d-flex h-100 flex-wrap>

  <a href="#" class="btn" v-b-tooltip title="Log out" v-on:click.prevent="logOut">
    <font-awesome-layers class="fa-fw fa-3x">
     <font-awesome-icon icon="circle" class="blade-blue"/>
     <font-awesome-icon icon="sign-out-alt" style="color:#fff"  transform="shrink-5.0"/>
</font-awesome-layers>
  </a>
  </b-col>
</b-row>
    <b-row>
        <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >

          <b-img src="../assets/480x320-blade.png" center fluid alt="Responsive image" style=" margin-top:5%"/>
                <b-card title=""  sub-title="" style=" margin-top:3%">
          <h5 class="blade-blue">Please choose your preferred region:</h5>
          <form role="form" v-on:submit.prevent="launchInstance()"  v-if="!busy">
                            <fieldset>
                                <div class="form-group">
                                 <select class="form-control" v-model="selectedInstance">
                                     <!-- <option disabled value="">Please select one</option> -->
<option v-for="option in instanceOptions">{{ option.displayName }}</option>

</select>
                                </div>

                                <!-- Change this to a button or input when using this as a form -->
                                <button type="submit" :disabled="selectedInstance === 'Select a region'" class="btn btn-lg btn-blade btn-block">Launch</button>
                                   <br/>

                            </fieldset>
                        </form>

                          <div class="loader"> <stretch v-if="busy" ></stretch> </div>
                            <b-alert :show="hasError" variant="danger" @dismissed="hasError=false">
               {{errorMsg}}
          </b-alert>

            </b-card>
        </b-col>
    </b-row>
    <div slot="footer" class="w-100">
      <license-footer></license-footer>
    </div>
 </b-container>
</template>

<script lang="js">

import { Stretch } from 'vue-loading-spinner'
import LicenseFooter from './LicenseFooter'
const ReferenceCodes = {

  Userpoolseatsnotavailable: 'c5c9a0f3b4f9ffe6a70fa0011edc990b',
  UseralreadyloggedintoSession: '441b97f121af081e7e01119641f97830'
}

export default {
  name: 'select-instance',
  components: {
    Stretch,
    LicenseFooter
  },
  props: [],
  mounted: async function () {
    const self = this

    const isLoggedIn = await self.$auth.isAuthenticated()

    if (!isLoggedIn) {
      self.$router.push('/')
    }

    try {
      self.instanceOptions = {

        'selectaregion': {

          id: 'nil',
          displayName: 'Select a region'
        }
      }
      self.hasError = false
      self.busy = true
      const response = await self.$appStream.getStreamingInstances()

      let ndx = null
      let instances = response.data

      for (ndx in instances) {
        let instance = instances[ndx]
        self.instanceOptions[instance.displayName] = instance
      }
      // console.log(response.data)

      self.busy = false
    } catch (error) {
      self.busy = false
      self.hasError = true
      self.errorMsg = 'an error occurred retrieving instances. refresh page and try again or contact your administrator'
    }
  },
  data () {
    return {

      selectedInstance: 'Select a region',
      errorMsg: '',
      hasError: false,
      busy: false,
      instanceOptions: { }
    }
  },
  methods: {

    launchInstance: async function () {
      let self = this
      self.hasError = false
      self.busy = true

      let instance = self.instanceOptions[self.selectedInstance]

      self.$appStream.getSignedUrl(instance).then(async response => {
        const refCode = response.data.referenceCode
        const url = response.data.result.streamingURL

        if (refCode && refCode === ReferenceCodes.Userpoolseatsnotavailable) {
          // rediect user
          self.$router.push('/activesessions')
        } else if (refCode && refCode === ReferenceCodes.UseralreadyloggedintoSession) {
          self.busy = false
          self.errorMsg = 'Your account is already logged into a different session. Please close all browser windows and try again.'
          self.hasError = true
        } else if (!url) {
          self.busy = false
          self.errorMsg = 'an error occurred fulfilling request. Please try again or contact your administrator'
          self.hasError = true
        } else {
          await self.$auth.logOut()
          window.location.href = url
        }
      }).catch(err => {
        if (err) {
          self.busy = false
          self.errorMsg = 'an error occurred fulfilling request. Please try again or contact your administrator'
          self.hasError = true
        }
      })
    },

    logOut: async function () {
      let self = this
      await self.$auth.logOut()
      self.$router.push('/')
    }
  },
  computed: {

  }
}
</script>

<style src="../assets/styles.css"></style>



// WEBPACK FOOTER //
// src/components/SelectInstance.vue